import { render, staticRenderFns } from "./ArticlesFilter.vue?vue&type=template&id=5fd62cd8&"
import script from "./ArticlesFilter.vue?vue&type=script&lang=js&"
export * from "./ArticlesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports